<template>
        <!--
    ********************************************************
    ****   FORMATO NUMERO 5 TABLA CON TEXTO             ****
    ****   COMO EN PAGINA cONSEJEROS DE LA JUDICATURA   ****
    ********************************************************
  -->
    <table class="table table-striped table-hover table-bordered mt-3 ">
                  <thead class="thead-dark">
                    <tr>
                      <th></th>
                      <th class="titulo" v-for="(titulo,subIndex) in titulos.split('|')" :key="subIndex">{{titulo}}</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr v-for="(contenido,index) in contenidos" :key="index" >
                      <th>{{index+1}}</th>
                      <th v-for="(subcontenido,index2) in contenido.TextoDelContenido.split('|')" :key="index2" class="contenido-tabla">{{subcontenido}}</th>
                    </tr>
                  </tbody>
                </table>
</template>

<script>
export default {
    props:{
        contenidos: Array,
        titulos: String
    },
    methods: {
      columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas
            return respuesta;
        }
    },
}
</script>

<style scoped>
 .titulo {
    font-size: 1.8em;
    font-family:'AntenaBeta';
  }
  .contenido-tabla{
    font-family: 'Myriad';
    font-size: 1.2em;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/TablaDeTexto.vue